'use strict';

import {XMLParser} from 'fast-xml-parser';

export class XmlParser extends XMLParser {
    constructor( xmlParserOptions : any = {} ) {
        // XML tags that will be put into arrays (the xml-parser would otherwise create a single object, if the tag is only found once)
        const arrayJpath = [
            'Yoonite.data.item', 'Yoonite.data.reference', 'Yoonite.data.file', 'Yoonite.data.item.property', 'Yoonite.data.reference.property',
            'Yoonite.metaModel', 'Yoonite.data', 'Yoonite.authorization',
            'Yoonite.metaModel.propertyType',
            'Yoonite.metaModel.valueSet', 'Yoonite.metaModel.valueSet.value', 'Yoonite.metaModel.valueSet.value.label',
            'Yoonite.metaModel.referenceType',
            'Yoonite.metaModel.itemType', 'Yoonite.metaModel.itemType.label', 'Yoonite.metaModel.itemType.icon',
            'Yoonite.metaModel.itemType.propertySet', 'Yoonite.metaModel.itemType.propertySet.label',
            'Yoonite.metaModel.referenceSet', 'Yoonite.metaModel.referenceSet.label',
            'Yoonite.metaModel.referenceSet.propertySet', 'Yoonite.metaModel.referenceSet.propertySet.label',
            'Yoonite.authorization.group', 'Yoonite.authorization.group.itemTypePermission', 'Yoonite.authorization.group.referenceSetPermission',
            'Yoonite.authorization.user', 'Yoonite.authorization.user.group'
        ];

        xmlParserOptions = {
            ignoreAttributes   : false,
            attributeNamePrefix: '@_',
            parseAttributeValue: false,
            parseTagValue      : false,
            isArray            : ( name : string, jpath : string, isLeafNode : boolean, isAttribute : boolean ) => {
                return !isAttribute && arrayJpath.includes( jpath );
            },
            ...xmlParserOptions
        };

        super( xmlParserOptions );
    }
}
